import { CustomImageBanner } from '@/screens/promo-apipromo/ui/CustomImageBanner/CustomImageBanner'

import { Popover } from '@/shared/ui/Popover'

import type { PromoImageSources } from '../assets/images'

import cl from './BenefitsSection.module.scss'

type BenefitCardProps = {
	banners: PromoImageSources
	className: string
	description: string
	title: string
	tooltip: string
}

const TooltipMark = ({ content }: { content: string }) => (
	<Popover
		as="span"
		className={cl.tooltip}
		content={content}
		placement="topRight"
		overlayInnerStyle={{ maxWidth: '25rem', padding: '16px' }}>
		<button className={cl.tooltipButton} type="button" aria-label="Подробнее">
			?
		</button>
	</Popover>
)

export const BenefitCard = ({ banners, className, description, title, tooltip }: BenefitCardProps) => (
	<article className={`${cl.card} ${className}`}>
		<CustomImageBanner
			fill
			imgAlt={banners.desktop.alt ?? ''}
			imgSrcDesk={banners.desktop.src}
			imgSrcMob={banners.mobile.src}
			imgSrcTablet={banners.tablet.src}
			imgDeskWidth={288}
			imgDeskHeight={360}
			imgTabletWidth={350}
			imgTabletHeight={380}
			imgMobWidth={343}
			imgMobHeight={205}
			link={banners.desktop.link ?? ''}
			disabled={!banners.desktop.link}
			title=""
		/>
		<TooltipMark content={tooltip} />
		<div className={cl.cardContent}>
			<strong dangerouslySetInnerHTML={{ __html: title }} />
			<span dangerouslySetInnerHTML={{ __html: description }} />
		</div>
	</article>
)
